import template from './context-detail-component.hogan.html';
import { HtmlComponent } from '../html-component';
import { Gui } from '../../gui';
import { SelectUserCommandParameters } from '../../commands/select-user-command-executor';
import { EmployeeDataType } from '../../../data-management/data-sources/sources/employees-data-source';
import { UserDetailComponent } from './user-detail/user-detail-component';
import { SelectAccountCommandParameters } from '../../commands/select-account-command-executor';
import { AccountDetailComponent } from './account-detail/account-detail-component';

export class ContextDetailComponent extends HtmlComponent {
    private authenticatedEmployee: EmployeeDataType;

    private userDetailComponent: UserDetailComponent;
    private accountDetailComponent: AccountDetailComponent;
    private activeComponent: UserDetailComponent | AccountDetailComponent;

    constructor(private gui: Gui) {
        super(template, {});
    }

    public init() {
        setTimeout(() => {
            this.authenticatedEmployee = this.gui.app.dataSourceLoader.authenticatedEmployee;
            this.initUserComponent();
            this.initAccountComponent();
        });
    }

    public resize() {
        this.activeComponent.init();
    }

    private initUserComponent() {
        this.userDetailComponent = new UserDetailComponent(this.gui, this.jqueryElement);
        this.gui.commandManager.selectUserCommandExecutor.commandExecuted.attach(
            (parameters: SelectUserCommandParameters) => {
                this.selectEmployee(parameters.userId);
            }
        );
    }

    public selectEmployee(employeeId?: number) {
        this.cleanComponents();
        this.userDetailComponent.setElement(employeeId || this.authenticatedEmployee._internal_datasource_id_);
        this.activeComponent = this.userDetailComponent;
    }

    private initAccountComponent() {
        this.accountDetailComponent = new AccountDetailComponent(this.gui, this.jqueryElement);
        this.gui.commandManager.selectAccountCommandExecutor.commandExecuted.attach(
            (parameters: SelectAccountCommandParameters) => {
                if (parameters.enable) {
                    this.cleanComponents();
                    this.accountDetailComponent.setElement(parameters.accountId);
                    this.activeComponent = this.accountDetailComponent;
                } else {
                    this.selectEmployee();
                }
            }
        );
    }

    private cleanComponents() {
        this.userDetailComponent.cleanCanvas();
        this.accountDetailComponent.cleanCanvas();
    }
}
